export enum ConfirmationTypesEnum {
  Sms = 'sms',
  Email = 'email',
  Otp = 'OTP',
}
